import { gql } from '@apollo/client';

export const CREATE_COLUMN = gql`
  mutation CreateColumn($params: CreateColumnInput!) {
    createColumn(params: $params) {
      success
      message
      errors
      data {
        id
        tableId
        columnName
        dataType
        description
        businessRules
        exampleValues
        isNullable
        isPrimaryKey
        isForeignKey
        foreignKeyReference
        keywords
        isCore
        alwaysInclude
        allowedValues
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_COLUMN = gql`
  mutation UpdateColumn($params: UpdateColumnInput!) {
    updateColumn(params: $params) {
      success
      message
      errors
      data {
        id
        tableId
        columnName
        dataType
        description
        businessRules
        exampleValues
        isNullable
        isPrimaryKey
        isForeignKey
        foreignKeyReference
        keywords
        isCore
        alwaysInclude
        allowedValues
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_COLUMN = gql`
  mutation DeleteColumn($params: DeleteColumnInput!) {
    deleteColumn(params: $params) {
      success
      message
      errors
    }
  }
`;

export const CREATE_COLUMN_EMBEDDING = gql`
  mutation CreateColumnEmbedding($params: CreateColumnEmbeddingInput!) {
    createColumnEmbedding(params: $params) {
      success
      message
      errors
    }
  }
`;
